<template>
  <div id="buyee-alliance-banner">
    <input type="hidden" id="buyee-item-code" :value="props.inputTagValue" />
  </div>
</template>

<script setup lang="ts">
type Props = {
  inputTagValue: string;
};
type BuyeeType = {
  ac: string;
  did: string;
  hid: string;
};
type FetchResponse = {
  script: string;
};

const props = defineProps<Props>();
const { notify } = useBugsnag();

const _buyee: BuyeeType = {
  ac: 'orientalbio-to-page',
  did: 'buyee-alliance-banner',
  hid: 'buyee-item-code',
};

const { data, status, error } = useFetch<FetchResponse>('/api/fetch-buyee-script', {
  method: 'POST',
  body: {
    ac: _buyee.ac,
    cache: false,
  },
});

watch(status, (newStatus: 'idle' | 'pending' | 'success' | 'error') => {
  if (newStatus === 'success' && data.value && data.value.script) {
    const script = document.createElement('script');
    script.text = data.value.script;
    script.async = true;
    document.getElementById(_buyee.did)?.appendChild(script);
  }
});

watch(error, (newError) => {
  if (newError) {
    notify(newError);
  }
});
</script>

<style scoped>
#buyee-alliance-banner {
  display: block;
}
</style>
